<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.general_id_information') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.businesses_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            multiple
            collapse-tags
            @change="selectAllFromSelect('model.businesses_id', businesses)"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ $t('common_words.date') }} *</label>
        <el-date-picker
          v-if="renderComponent"
          class="required-date"
          v-model="model.date"
          type="date"
          :placeholder="$t('common_words.date_pick')"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('samples.ground_select_element') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select nutrient-rels shadow-sm"
            size="large"
            v-model="model.ground_nutrient_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in ground_nutrients"
              class="select-primary"
              :value="option.id"
              :label="option.description"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group has-label">
          <label class="text-transform-none width-label">{{
            $t('common_words.crop_selection')
          }}</label>
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select crop-rels shadow-sm"
            size="large"
            v-model="model.crop_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            @change="getCropVarieties"
          >
            <el-option
              v-for="option in crops"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.zones') }}:</label
          >
          <br />
          <el-select
            @change="getSubzonesByZone(model.zone_id)"
            clearable
            class="select-primary custom-width-select zone-rels shadow-sm"
            size="large"
            v-model="model.zone_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in zones"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label class="text-transform-none width-label">{{
            $t('common_words.sub_zones')
          }}</label>
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select subzone-rels shadow-sm"
            size="large"
            v-model="model.subzone_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in subzonesByZone"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label class="text-transform-none width-label">{{
            $t('common_words.variety_select')
          }}</label>
          <br />
          <el-select
            clearable
            multiple
            collapse-tags
            class="select-primary custom-width-select cropvariety-rels shadow-sm"
            size="large"
            v-model="model.crop_variety_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            @change="
              selectAllFromSelect('model.crop_variety_id', crop_varieties)
            "
          >
            <el-option
              v-for="option in crop_varieties"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row" v-show="errorAlert">
      <div class="col-lg-12">
        <br />
        <el-alert
          ref="error_alert"
          :title="$t('common_words.errors')"
          type="error"
          >{{ error }}</el-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';

export default {
  data() {
    return {
      model: {
        businesses_id: null,
        date: null,
        ground_nutrient_id: null,
        crop_id: null,
        zone_id: null,
        subzone_id: null,
        crop_variety_id: [],
      },
      businesses: null,
      ground_nutrients: [],
      crops: [],
      zones: [],
      subzones: [],
      subzonesByZone: [],
      crop_varieties: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = [];
          this.$emit('fillrangeGroundForm', 'firstStep', {
            names_business: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.businesses_id.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else if (this.model.date == null) {
            return this.validationInputsRequired('date');
          } else if (this.model.ground_nutrient_id == null) {
            for (let index of document.getElementsByClassName(
              'nutrient-rels'
            )) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else if (
            this.model.crop_variety_id.length > 0 &&
            (!this.model.crop_id || this.model.crop_id === '')
          ) {
            for (let index of document.getElementsByClassName('crop-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }

            return false;
          } else if (
            this.model.crop_id &&
            this.model.crop_id != '' &&
            this.model.crop_variety_id.length == 0
          ) {
            for (let index of document.getElementsByClassName(
              'cropvariety-rels'
            )) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }

            return false;
          } else {
            return true;
          }
        });
    },
    getSubzonesByZone(zoneId) {
      if (isset(zoneId)) {
        const value = this.zones.find((zone) => zone.id == zoneId);
        this.subzonesByZone = value.subzones;
        this.model.subzone_id = null;
      } else {
        this.model.subzone_id = null;
        this.subzonesByZone = [];
      }
    },
    getCropVarieties() {
      if (this.model.crop_id != null && this.model.crop_id != '') {
        this.showHideLoading(true);
        Axios.getMasters('cropvarieties/' + this.model.crop_id)
          .then((response) => {
            this.crop_varieties = this.concatAll(response.data.data);
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.crop_varieties = [];
      }
    },
  },
  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('zones'),
        Axios.getMasters('subzone'),
        Axios.getMasters('grounds/nutrients/index'),
        Axios.getMasters('farms/crops'),
      ])
        .then(
          ([
            responseBusinesses,
            responseZones,
            responseSubzones,
            responseNutrients,
            responseCrops,
          ]) => {
            this.businesses = this.concatAll(responseBusinesses.data.data);
            this.zones = responseZones.data.data;
            this.subzones = responseSubzones.data.data;
            this.ground_nutrients = responseNutrients.data.data;
            this.crops = responseCrops.data.data;
            let editForm = JSON.parse(sessionStorage.getItem('editForm'));
            if (this.isUpdate() && editForm) {
              this.model.id = editForm.id;
              this.model.businesses_id = editForm.businesses_id;
              this.model.date = moment(editForm.date).format('Y-M-D');
              this.model.ground_nutrient_id = editForm.ground_nutrient_id;
              this.model.crop_id = editForm.crop_id;
              this.model.zone_id = editForm.zone_id;
              if (!this.zones.some((z) => z.id == this.model.zone_id)) {
                this.model.zone_id = null;
              }

              this.getCropVarieties();

              this.model.crop_variety_id = editForm.crop_variety_ids || [];

              if (isset(this.model.zone_id)) {
                const value = this.zones.find(
                  (zone) => zone.id == this.model.zone_id
                );
                this.subzonesByZone = value ? value.subzones : [];
              } else {
                this.subzonesByZone = [];
              }

              this.model.subzone_id = editForm.subzone_id;
              if (
                !this.subzonesByZone.some(
                  (sz) => sz.id == this.model.subzone_id
                )
              ) {
                this.model.subzone_id = null;
              }
            }
            setTimeout(() => {
              this.showHideLoading();
            }, 1000);
          }
        )
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
};
</script>
